import { Stack, useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { formatISO } from 'date-fns';
import { FullHeightWrapper } from '~/layout/components/full-height-wrapper/FullHeightWrapper';
import { PageHeader } from '~/layout/components/page-header/PageHeader';
import { LogMealHeader } from '~/meal/components/log-meal-header/LogMealHeader';
import { useCurrentOverviewDate } from '~/calendar/hooks/useCurrentOverviewDate';
import { RightSidebar } from '~/layout/components/right-sidebar/RightSidebar';
import { MealLogSidebar } from '~/meal/components/meal-log-sidebar/MealLogSidebar';

export default function MealDetailLayout() {
  const { t } = useTranslation('meal');
  const router = useRouter();
  const currentDate = useCurrentOverviewDate();

  const handleDateChange = (date: Date) => {
    router.replace(`/meals/${formatISO(date, { representation: 'date' })}`);
  };

  return (
    <FullHeightWrapper>
      {/* Registers the coach + favourites rail so the mobile drawer (opened by
          the header trigger) can host it — desktop renders the same rail. */}
      <MealLogSidebar />
      <LogMealHeader
        currentDate={currentDate}
        onDateChange={handleDateChange}
      />
      <PageHeader
        className="md:hidden"
        title={t('logMeal')}
        actions={<RightSidebar.Trigger />}
      />
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen name="[date]" />
      </Stack>
    </FullHeightWrapper>
  );
}
